module.exports = __webpack_public_path__ + "img/delivery02.2c3bbf1f.png";